import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  // Do not overwrite a caller-supplied Authorization header (e.g. Pro Space
  // sends its own `bc_pro_token`). Also, never inject the admin token onto
  // `/pro/*` endpoints — pro requests must stay with the pro token even if
  // an admin session cookie/token is also present in localStorage.
  const existing =
    (config.headers && (config.headers.Authorization || config.headers.authorization)) || "";
  const url = config.url || "";
  const isProEndpoint = url.startsWith("/pro") || url.includes("/pro/");
  if (!existing && !isProEndpoint) {
    const token = localStorage.getItem("bc_admin_token");
    if (token) config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;

export const resolveMedia = (url) => {
  if (!url) return "";
  if (url.startsWith("http")) return url;
  return `${BACKEND_URL}${url}`;
};
